import { memo, useEffect, useState } from 'react'

/**
 * Live casino card, admin (ported from tenexch admin CardImg, user 2026-10-18):
 * when a face-down card is revealed, the BACK disappears first (opacity 1 → 0,
 * CARD_BLINK_MS), then the face shows. Not the player site's flip. Result
 * modals keep plain <img>. Same props as <img>; `src` is the card URL
 * (".../1.png" or ".../0.png" = card back).
 */
const CARD_BLINK_MS = 150 // keep in step with .casino-card-blink in styles/index.css

// A card that MOUNTS face-up (strips that only draw dealt cards) blinks too —
// but not while a page is first filling in, or every card would blink on load.
const MOUNT_GRACE_MS = 1500
let pagePath = null
let baselineAt = 0
let mountedCards = 0
const now = () => (typeof performance !== 'undefined' ? performance.now() : Date.now())
const pageJustOpened = () => {
  const path = typeof window !== 'undefined' ? window.location.pathname : ''
  // A new page, or a repeat visit to the same table (no card left on screen).
  if (path !== pagePath || mountedCards === 0) {
    pagePath = path
    baselineAt = now()
  }
  return now() - baselineAt <= MOUNT_GRACE_MS
}

const isBack = (src) => !src || /\/[01]\.png(\?.*)?$/i.test(String(src))
const backOf = (src) => String(src).replace(/[^/]*$/, '1.png')

const CardImg = memo(function CardImg({ src, className = '', ...rest }) {
  const [prevSrc, setPrevSrc] = useState(src)
  const [blink, setBlink] = useState(() => !isBack(src) && !pageJustOpened())

  // Decided during render, so the face never paints for a frame before the blink.
  if (src !== prevSrc) {
    setPrevSrc(src)
    setBlink(isBack(prevSrc) && !isBack(src) && !pageJustOpened())
  }

  useEffect(() => {
    mountedCards += 1
    return () => {
      mountedCards -= 1
    }
  }, [])

  // Timer, not animationend: a hidden strip (display:none) never fires it.
  useEffect(() => {
    if (!blink) return undefined
    const t = setTimeout(() => setBlink(false), CARD_BLINK_MS)
    return () => clearTimeout(t)
  }, [blink])

  const cls = [className, blink ? 'casino-card-blink' : ''].filter(Boolean).join(' ')
  return <img src={blink ? backOf(src) : src} {...rest} className={cls || undefined} />
})

export default CardImg
